<template>
  <div>
    <rightNav></rightNav>
    <lateralNavigation2></lateralNavigation2>
    <div class="us" >
       <div style="border: 1px gainsboro solid">
         <p style="margin-left: 8px;margin-top: 4px; margin-bottom: 4px; font-family: 微软雅黑">
         店铺名称：<a style="text-decoration: none;color: #1a7aff" href="https://www.kangbeichen.com.cn/#/categoryProduct?id=10&name=%E6%B7%B1%E5%9C%B3%E5%B8%82%E6%80%9D%E7%80%9A%E8%BF%AA%E7%BD%91%E7%BB%9C%E6%8A%80%E6%9C%AF%E6%9C%89%E9%99%90%E5%85%AC%E5%8F%B8">
           深圳市思瀚迪网络技术有限公司</a><br/><br/>
         联系信息：樊美琴&nbsp;&nbsp;&nbsp;&nbsp;13823203716<br/><br/>
         联系地址：深圳市龙岗区园山街道大运软件小镇20栋101<br/>
         </p>
       </div>

      <div style="border: 1px gainsboro solid;margin-top: 10px">
        <p style="margin-left: 8px;margin-top: 4px; margin-bottom: 4px; font-family: 微软雅黑">
          店铺名称：<a style="text-decoration: none;color: #1a7aff" href="https://www.kangbeichen.com.cn/#/categoryProduct?id=11&name=%E6%B7%B1%E5%9C%B3%E5%B8%82%E5%BA%B7%E8%B4%9D%E5%AE%B8%E4%BF%A1%E6%81%AF%E6%8A%80%E6%9C%AF%E6%9C%89%E9%99%90%E5%85%AC%E5%8F%B8">
          深圳市康贝宸信息技术有限公司</a><br/><br/>
          联系信息：严进&nbsp;&nbsp;&nbsp;&nbsp;15817470772<br/><br/>
          联系地址：深圳市福田区园岭街道八卦四路411栋8楼7房<br/>
        </p>
      </div>

      <br/><br/>
    </div>
  </div>

</template>

<script>
import api from "@/api";
import {listSearchMixin} from '../../config/mixin'
import rightNav from '../../components/canvasShow/rightNav'
import lateralNavigation2 from '../../components/base/lateralNavigation2'

export default {
  mixins: [listSearchMixin],
  components: {rightNav, lateralNavigation2},
  watch: {

  },
  data () {
	  return {
			type: '',
			records: {}
		}
	},

  methods:{


	}
}
</script>

<style>
	.us{
		width: 1250px;
		margin: 0 auto;
    margin-top: 50px;
	}
</style>



// WEBPACK FOOTER //
// src/views/us/storelist.vue